
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/static-products",
      function () {
        return require("private-next-pages/[lang]/static-products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/static-products"])
      });
    }
  